import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const PRODUCT_LOGO_URL = "https://plus.unsplash.com/premium_photo-1679913792906-13ccc5c84d44?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";
const PRODUCT_IMAGES = [
  PRODUCT_LOGO_URL,
  "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  "https://plus.unsplash.com/premium_photo-1678099940967-73fe30680949?q=80&w=2960&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
];

function generateDummyProducts(brandName) {
  return Array.from({ length: 10 }).map((_, i) => ({
    id: i + 1,
    name: `${brandName} Product ${i + 1}`,
    description: `This is a description for ${brandName} Product ${i + 1}. High quality, sustainable, and innovative.`,
    images: PRODUCT_IMAGES,
    price: `₹${999 + i * 100}`,
    category: i % 2 === 0 ? 'Featured' : 'General'
  }));
}

export default function BrandProductContentPage() {
  const { brandId } = useParams();
  const navigate = useNavigate();
  const brandName = (() => {
    try {
      const { DEMO_BRANDS } = require('../components/BrandsTable');
      const found = DEMO_BRANDS.find(b => String(b.id) === String(brandId));
      return found ? found.name : 'Brand';
    } catch {
      return 'Brand';
    }
  })();
  const [search, setSearch] = React.useState('');
  const [selectedProduct, setSelectedProduct] = React.useState(null);
  const [modalImgIdx, setModalImgIdx] = React.useState(0);
  // Feedback state for modal
  const [feedback, setFeedback] = React.useState('');
  const [feedbackSent, setFeedbackSent] = React.useState(false);
  const [showFeedbackForm, setShowFeedbackForm] = React.useState(false);
  const allProducts = generateDummyProducts(brandName);
  const filtered = allProducts.filter(p =>
    p.name.toLowerCase().includes(search.toLowerCase()) ||
    p.description.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={{width:'100vw',minHeight:'100vh',background:'rgb(228 219 210)',padding:'0',margin:'0'}}>
      <div style={{maxWidth:1400,margin:'0 auto',padding:'2.5rem 2rem 2rem 2rem'}}>
        <input
          type="text"
          placeholder="Search products..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{padding:'0.9rem 1.3rem',borderRadius:10,border:'1.5px solid #00bfae',fontSize:'1.13rem',minWidth:220,maxWidth:'100%',width:'100%',background:'#f8faf8',marginBottom:'2.5rem',boxSizing:'border-box',boxShadow:'0 1px 6px rgba(60,60,90,0.07)'}}
        />
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(270px,1fr))',gap:'2rem',marginBottom:'2.5rem'}}>
          {filtered.length === 0 && <div style={{gridColumn:'1/-1',color:'#888'}}>No products found.</div>}
          {filtered.map(product => (
            <div key={product.id} style={{background:'#fff',borderRadius:16,padding:'1.5rem',boxShadow:'0 2px 12px rgba(60,60,90,0.08)',display:'flex',flexDirection:'column',alignItems:'center',cursor:'pointer',transition:'box-shadow 0.2s'}} onClick={() => {
              setSelectedProduct(product);
              setModalImgIdx(0);
              setFeedback('');
              setFeedbackSent(false);
              setShowFeedbackForm(false);
            }}>
              <div style={{display:'flex',gap:'0.7rem',marginBottom:'1rem',justifyContent:'center'}}>
                {product.images.map((img, idx) => (
                  <img key={idx} src={img} alt={product.name + ' img ' + (idx+1)} style={{width:70,height:70,objectFit:'cover',borderRadius:10,border:'1.5px solid #e6f4f1'}} />
                ))}
              </div>
              <div style={{fontWeight:700,fontSize:'1.13rem',color:'#004443',marginBottom:'0.3rem',textAlign:'center'}}>{product.name}</div>
              <div style={{color:'#888',fontSize:'1em',marginBottom:'0.2rem',textAlign:'center'}}>{product.category}</div>
              <div style={{color:'#222',fontSize:'1.04em',marginBottom:'0.2rem',textAlign:'center'}}>{product.description}</div>
              <div style={{color:'#00bfae',fontWeight:700,marginBottom:'0.2rem'}}>{product.price}</div>
            </div>
          ))}
        </div>
      </div>
      {/* Modal for product details */}
      {selectedProduct && (
        <div style={{position:'fixed',top:0,left:0,width:'100vw',height:'100vh',background:'rgba(0,0,0,0.25)',zIndex:2000,display:'flex',alignItems:'center',justifyContent:'center'}} onClick={() => setSelectedProduct(null)}>
          <div style={{background:'#fff',borderRadius:18,padding:'2.5rem 2.2rem',minWidth:340,maxWidth:820,boxShadow:'0 4px 32px rgba(60,60,90,0.18)',position:'relative',display:'flex',flexDirection:'row',gap:'2.5rem',alignItems:'stretch'}} onClick={e => e.stopPropagation()}>
            <button onClick={() => setSelectedProduct(null)} style={{position:'absolute',top:18,right:18,background:'#e6f4f1',color:'#004443',border:'none',borderRadius:8,padding:'0.3rem 1rem',fontWeight:700,fontSize:'1.3rem',cursor:'pointer',zIndex:2}}>×</button>
            {/* Left: Product details and gallery */}
            <div style={{flex:'1 1 0',minWidth:0,maxWidth:370,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'flex-start',paddingRight:'0.5rem'}}>
              <img src={selectedProduct.images[modalImgIdx]} alt={selectedProduct.name} style={{width:220,height:220,objectFit:'cover',borderRadius:14,boxShadow:'0 2px 12px rgba(60,60,90,0.10)',marginBottom:'1.1rem'}} />
              <div style={{display:'flex',gap:'0.5rem',marginBottom:'1rem',flexWrap:'wrap',justifyContent:'center'}}>
                {selectedProduct.images.map((img, idx) => (
                  <img key={idx} src={img} alt={selectedProduct.name + ' thumb ' + (idx+1)} style={{width:48,height:48,objectFit:'cover',borderRadius:8,border:modalImgIdx===idx?'2.5px solid #00bfae':'1.5px solid #e6f4f1',cursor:'pointer',boxShadow:modalImgIdx===idx?'0 2px 8px #00bfae33':'none'}} onClick={()=>setModalImgIdx(idx)} />
                ))}
              </div>
              <div style={{display:'flex',gap:'0.7rem',marginBottom:'1.2rem',flexWrap:'wrap',justifyContent:'center',width:'100%'}}>
                <button style={{background:'#e6f4f1',color:'#004443',border:'none',borderRadius:8,padding:'0.5rem 1.2rem',fontWeight:600,cursor:'pointer',flex:'1 1 120px',minWidth:120}} onClick={() => {
                  // Download image
                  const link = document.createElement('a');
                  link.href = selectedProduct.images[modalImgIdx];
                  link.download = `${selectedProduct.name.replace(/\s+/g,'_')}_image${modalImgIdx+1}.jpg`;
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }}>Download Image</button>
                <button style={{background:'#fff',color:'#00bfae',border:'1.5px solid #00bfae',borderRadius:8,padding:'0.5rem 1.2rem',fontWeight:600,cursor:'pointer',flex:'1 1 120px',minWidth:120}} onClick={()=>alert('Change image functionality coming soon!')}>Change Image</button>
              </div>
              <div style={{textAlign:'center',width:'100%'}}>
                <div style={{fontWeight:700,fontSize:'1.25rem',color:'#004443',marginBottom:'0.4rem'}}>{selectedProduct.name}</div>
                <div style={{color:'#888',fontSize:'1.05em',marginBottom:'0.2rem'}}>{selectedProduct.category}</div>
                <div style={{color:'#222',fontSize:'1.08em',marginBottom:'0.2rem'}}>{selectedProduct.description}</div>
                <div style={{color:'#00bfae',fontWeight:700,marginBottom:'0.2rem'}}>{selectedProduct.price}</div>
              </div>
            </div>
            {/* Right: Feedback form or feedback result */}
            <div style={{flex:'1 1 0',minWidth:0,maxWidth:340,display:'flex',alignItems:'flex-start',justifyContent:'center'}}>
              {!feedbackSent ? (
                <form onSubmit={e => {e.preventDefault(); setFeedbackSent(true);}} style={{background:'#f8faf8',borderRadius:12,padding:'1.3rem 1.2rem',boxShadow:'0 1px 6px rgba(60,60,90,0.07)',width:'100%',maxWidth:340}}>
                  <h3 style={{marginBottom:'1.1rem',color:'#004443',fontWeight:700,fontSize:'1.1rem'}}>Send Feedback to Suspire Admin</h3>
                  <div style={{marginBottom:'0.7rem'}}>
                    <label style={{fontWeight:600,color:'#004443',fontSize:'1em'}}>Product Name</label>
                    <input type="text" value={selectedProduct.name} readOnly style={{width:'100%',borderRadius:8,border:'1.2px solid #e6f4f1',padding:'0.7rem',fontSize:'1em',marginTop:'0.2rem',background:'#f4f8f8'}} />
                  </div>
                  <div style={{marginBottom:'0.7rem'}}>
                    <label style={{fontWeight:600,color:'#004443',fontSize:'1em'}}>Image URL</label>
                    <input type="text" value={selectedProduct.images[modalImgIdx]} readOnly style={{width:'100%',borderRadius:8,border:'1.2px solid #e6f4f1',padding:'0.7rem',fontSize:'1em',marginTop:'0.2rem',background:'#f4f8f8'}} />
                  </div>
                  <div style={{marginBottom:'1.1rem'}}>
                    <label style={{fontWeight:600,color:'#004443',fontSize:'1em'}}>Your Feedback</label>
                    <textarea required value={feedback} onChange={e => setFeedback(e.target.value)} placeholder="Describe any changes or corrections needed for this product content..." rows={3} style={{width:'100%',borderRadius:8,border:'1.2px solid #00bfae',padding:'0.8rem',fontSize:'1em',marginTop:'0.2rem',background:'#fff'}} />
                  </div>
                  <button type="submit" style={{background:'#00bfae',color:'#fff',border:'none',borderRadius:8,padding:'0.7rem 2rem',fontWeight:700,fontSize:'1.05rem',cursor:'pointer'}}>Send</button>
                </form>
              ) : (
                <div style={{background:'#e6f4f1',borderRadius:12,padding:'1.3rem 1.2rem',boxShadow:'0 1px 6px rgba(60,60,90,0.07)',width:'100%',maxWidth:340}}>
                  <h3 style={{marginBottom:'1.1rem',color:'#004443',fontWeight:700,fontSize:'1.1rem'}}>Feedback Submitted</h3>
                  <div style={{marginBottom:'0.7rem'}}>
                    <b>Product Name:</b> {selectedProduct.name}
                  </div>
                  <div style={{marginBottom:'0.7rem'}}>
                    <b>Image URL:</b> <span style={{wordBreak:'break-all'}}>{selectedProduct.images[modalImgIdx]}</span>
                  </div>
                  <div style={{marginBottom:'0.7rem'}}>
                    <b>Your Feedback:</b> {feedback}
                  </div>
                  <div style={{marginTop:'1.1rem',color:'#388e3c',fontWeight:700}}>Feedback sent!</div>
                  <button onClick={()=>{setFeedback('');setFeedbackSent(false);}} style={{marginTop:'1.2rem',background:'#00bfae',color:'#fff',border:'none',borderRadius:8,padding:'0.6rem 1.5rem',fontWeight:700,fontSize:'1.01rem',cursor:'pointer'}}>Send Another Feedback</button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
